import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svglistadosperson',
  templateUrl: './svglistadosperson.component.html',
  styleUrls: ['./svglistadosperson.component.css']
})
export class SvglistadospersonComponent implements OnInit {
  @Input() color: string;

  constructor() { }

  ngOnInit() {
  }

}
